import { SERVER_URLS } from "../../appConstants";
import { getToken } from "../authentication";

export const updateIncentiveStatus = async (id,status) => {
    try {
        const token = getToken();
        const response = await fetch(
            SERVER_URLS.BACKEND_SERVER + `/dsp/incentives/update/${id}`,
           {
                method: "PUT",
                body: JSON.stringify({ status }),
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Failed to fetch bank details.");
        }
        return res;
    } catch (err) {
        console.log("err", err);
    }
}


export const updateIncentive = async (id,incentive) => {
    try {
        const token = getToken();
        const response = await fetch(
            SERVER_URLS.BACKEND_SERVER + `/dsp/incentives/update/${id}`,
           {
                method: "PUT",
                body: incentive,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Failed to fetch bank details.");
        }
        return res;
    } catch (err) {
        console.log("err", err);
    }
}
